let en = {
  translations: {
    organisation: 'Organisation',
    organisations: 'Organisations',
  },
};

export default en;
